import React from "react"
import { FormProvider, useForm, UseFormProps } from "react-hook-form"
import { ObjectSchema } from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { ButtonGroupActionsProps } from "app/models/buttonGroup"
import { ValidationProvider } from "./ValidationContext/ValidationContext"
import { makeNullableDates } from "./utils"
import ButtonGroup from "../ButtonGroup/ButtonGroup"

export interface IForm {
  children?: React.ReactNode
  onSubmit?: (data?: any) => void
  validationSchema?: ObjectSchema<any>
  cySelector: string
  formId?: string
  defaultValues?: UseFormProps["defaultValues"]
  actions?: ButtonGroupActionsProps[]
}

const Form: React.FC<IForm> = ({
  children,
  defaultValues,
  validationSchema,
  onSubmit,
  cySelector,
  formId,
  actions,
  ...rest
}) => {
  const mutatedSchema = makeNullableDates(validationSchema)

  const methods = useForm({
    ...(mutatedSchema ? { resolver: yupResolver(mutatedSchema) } : {}),
    defaultValues,
  })
  const { handleSubmit } = methods

  const handleSubmitHandler = (data: any) => {
    onSubmit?.(data)
  }

  return (
    <ValidationProvider schema={validationSchema}>
      <FormProvider {...methods}>
        <form id={formId} data-cy={cySelector} aria-label="form" onSubmit={handleSubmit(handleSubmitHandler)} {...rest}>
          {children}
          {actions && <ButtonGroup actions={actions} formId={formId} />}
        </form>
      </FormProvider>
    </ValidationProvider>
  )
}

export default Form
